import dayjs from "dayjs";

export const browserDetection = () => {
  var ua = navigator?.userAgent,
    tem,
    browser,
    version;

  var browserRegex =
    /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i;

  var ieVersionRegex = /\brv\s*:\s*(\d+)/i;

  var versionRegex = /version\/(\d+)/i;

  var matches = ua.match(browserRegex);

  if (/trident/i.test(matches[1])) {
    tem = ua.match(ieVersionRegex);
    browser = "IE";
    version = tem[1] || "";
  } else if (matches[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    browser = tem != null ? tem[1].replace("OPR", "Opera") : "Chrome";
    version = tem != null ? tem[2] : "";
  } else {
    browser = matches[1];
    version = matches[2];
    if ((tem = ua.match(versionRegex)) != null) version = tem[1];
  }

  return browser;
};

export const getPatientPractitionerObj = (patientObj, practitionerData,currentUserSpeciality) => {
  const patient = {};
  const practitioner = {};

  if (patientObj?.patientObj) {
    if (patientObj.patientObj.name && patientObj.patientObj.name.length > 0) {
      const patientNameObj = patientObj.patientObj.name.find(
        (name) => name.use === "official"
      );
      if (patientNameObj) {
        const fullName =
          patientNameObj.text ||
          `${patientNameObj.given.join(" ")} ${patientNameObj.family}`;
        if (fullName) {
          patient.patient_name = fullName;
        }
      }
    }
    if (patientObj.patientObj.birthDate) {
      patient.patient_dob = dayjs(patientObj.patientObj.birthDate).format("MM/DD/YYYY");
    }
    if (patientObj.patientObj.gender) {
      patient.patient_gender = patientObj.patientObj.gender;
    }
    if (patientObj.patientObj.id) {
      patient.patient_id = patientObj.patientObj.id;
    }
  }

  if (practitionerData) {
    if (practitionerData.name && practitionerData.name.length > 0) {
      const practitionerNameObj = practitionerData.name.find(
        (name) => name.use === "official"
      );
      if (practitionerNameObj) {
        const fullName =
          practitionerNameObj.text ||
          `${practitionerNameObj.prefix.join(
            " "
          )} ${practitionerNameObj.given.join(" ")} ${
            practitionerNameObj.family
          }`;
        if (fullName) {
          practitioner.practitioner_name = fullName;
        }
      }
    }
    if (
      currentUserSpeciality || practitionerData?.qualification?.length>0
    ) {
      practitioner.practitioner_speciality =currentUserSpeciality ||  practitionerData?.qualification?.[0]?.code?.text
      // const qualificationObj = practitionerData.qualification[0];
      // if (qualificationObj.code && qualificationObj.code.text) {
      //   practitioner.practitioner_speciality = qualificationObj.code.text;
      // }
    }
    if (practitionerData.telecom && practitionerData.telecom.length > 0) {
      const emailObj = practitionerData.telecom.find(
        (telecom) => telecom.system === "email"
      );
      if (emailObj && emailObj.value) {
        practitioner.practitioner_email = emailObj.value;
      }
      const phoneObj = practitionerData.telecom.find(
        (telecom) => telecom.system === "phone" && telecom.use === "mobile"
      );
      if (phoneObj && phoneObj.value) {
        practitioner.practice_phone_number = phoneObj.value;
      }
    }
  }

  return { patient, practitioner };
};

export const extractPatientAndEncounterIdFromComposition = (payload) => {
  const encounterRef = payload?.encounter?.reference;
  const soapEncounterId = encounterRef?.startsWith("Encounter/") ? encounterRef.split("/")[1] : null;
  const patientRef = payload?.subject?.reference;
  const soapPatientId = patientRef?.startsWith("Patient/") ? patientRef.split("/")[1] : null;
  return { soapPatientId, soapEncounterId };
};

export const hasGenClinicalNotesObservation = (observations) => {
  if (!Array.isArray(observations)) return false;
  return observations.some(
    (obs) =>
      obs?.resource?.code?.coding?.some(
        (coding) => coding?.code === "gen-clinical-notes"
      )
  );
};